// 1. Define the global array to store the classes
export const CLASSES_TESTED: any[] = [];

// 2. Define the Stage 3 class decorator
export function DECORATOR__class_serialization_tested(target: Function, context: ClassDecoratorContext) {
  // Ensure we are decorating a class
  if (context.kind === 'class') {
    CLASSES_TESTED.push(target);
  }
}
